import React, { Component } from "react";
import { Toast } from "antd-mobile";
import { getPathParams } from "../../utils/utils";
import { contractPathList } from '../../services/contractManage';
import { aes } from "lujing-fe-js-encryption";
import styles from './index.less';
import NoData from "../../components/NoData";
export default class contractManage extends Component {
  state = {
    getParams: getPathParams(this.props.location.search),
    contractList: []
  }

  componentDidMount() {
    const obj = getPathParams(this.props.location.search);
    const {key} = obj;
    const data = JSON.parse(aes.decryption(key)) 
    this.setState({
      getParams: {...data}
    });
    this.getContractPathList(data);
  }

  getContractPathList = (obj) => {
    const { truckBrokerCompanyCode = '' } = obj;
    contractPathList({ truckBrokerCompanyCode}).then(res => {
      if(+res.code !== 0) {
        Toast.fail(res.msg);
        return;
      }
      this.setState({
        contractList: res.data || []
      });
    });
  }

  openDetail = item => {
    const { type } = item;
    const { getParams: { truckBrokerCompanyCode, mobile } } = this.state;
    const url =  `/contractDetail?type=${type}&truckBrokerCompanyCode=${truckBrokerCompanyCode}&mobile=${mobile}`;
    this.props.history.push(url);
  }

  render() {
    const {contractList} = this.state;
    return (
      <div className={styles.contractBox}>
        {contractList.length > 0 ? <div className={styles.contractList}>
             {contractList.map(item => {
                return <div key={`${item.title}-${item.type}`} className={styles.contractItem} onClick={() => this.openDetail(item)}>
                    <div className={styles.title}>{item.agreementName }</div>
                    <div className={styles.jumpIcon}/>
                </div>
              })}
          </div>
        : <NoData/>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/contractManage/index.js